import { useMutation } from "@shared/lib/hooks";
import { FinanceApprovalService } from "../services/FinanceApprovalService";
import { ToastService } from "@shared/lib/services";
import {
  FINANCE_APPROVAL_QUERY_KEY,
  FINANCE_APPROVAL_QUERY_KEY_ID,
} from "../constants";
import {
  BRIEF_LIST_QUERY_KEY,
  BRIEF_LOT_FACETS_QUERY_KEY,
} from "@entities/brief/lib/constants";
export function usePurchaseNonProfitableLot(briefId: string) {
  const {
    mutate: purchaseNonProfitable,
    isLoading: isPurchasingNonProfitable,
    isSuccess: isPurchasedNonProfitable,
    variables,
  } = useMutation<{ purchaseLotId: string; purchaseLotItemsId: string }, void>({
    mutationFn: ({ purchaseLotId, purchaseLotItemsId }) =>
      FinanceApprovalService.purchaseNonProfitableLot(
        purchaseLotId,
        purchaseLotItemsId
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c, data, variables) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_LOT_FACETS_QUERY_KEY(briefId)],
      });
      c.invalidateQueries({
        queryKey: [...FINANCE_APPROVAL_QUERY_KEY],
      });
      c.invalidateQueries({
        queryKey: [...FINANCE_APPROVAL_QUERY_KEY_ID(variables.purchaseLotId)],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_LIST_QUERY_KEY, briefId],
      });
    },
  });

  return {
    purchaseNonProfitable,
    isPurchasingNonProfitable,
    isPurchasedNonProfitable,
    variables,
  };
}
